import CookieService from './CookieService';

const TokenService = {
  accessCookieName: 'BHP_SESSION',
  refreshCookieName: 'BHP_REFRESH_TOKEN',

  hasAccessToken(): boolean {
    return TokenService.getAccessTokenCookie() !== null;
  },

  getAccessTokenCookie(): string | null {
    return CookieService.getCookie(TokenService.accessCookieName);
  },

  storeAccessTokenCookie(accessToken: string, expiresIn: number): void {
    CookieService.setCookie(
      TokenService.accessCookieName,
      accessToken,
      expiresIn
    );
  },

  removeAccessTokenCookie(): void {
    CookieService.setCookie(TokenService.accessCookieName, '', -10);
  },

  hasRefreshToken(): boolean {
    return TokenService.getRefreshTokenCookie() !== null;
  },

  getRefreshTokenCookie(): string | null {
    return CookieService.getCookie(TokenService.refreshCookieName);
  },

  storeRefreshTokenCookie(refreshToken: string): void {
    // refresh token is 24 hours valid
    const days = 1;
    const hours = 24;
    const minutes = 60;
    const seconds = 60;
    CookieService.setCookie(
      TokenService.refreshCookieName,
      refreshToken,
      days * hours * minutes * seconds
    );
  },

  removeRefreshTokenCookie(): void {
    CookieService.setCookie(TokenService.refreshCookieName, '', -10);
  }
};

export default TokenService;
